import { TAdditionalOptions } from '@/domain/FullCalendar.domain';

export const createOptionsPrice = (
    selectedOptions: { [key: number]: string },
    ticketsSum: string,
    options?: TAdditionalOptions
) => {
    if (!selectedOptions || !options) {
        return 0;
    }

    return Object.entries(selectedOptions).reduce((sum, [id, optionId]) => {
        const option = Object.values(options)?.find((option) => option.id === id);
        const price = option?.values[+optionId]?.price || 0;

        const res = option?.base === '%' ? +ticketsSum * (+price / 100) : price || 0;
        return sum + +res;
    }, 0);
};
